import React from 'react';
import { Payment } from '../types';

interface PaymentsTableProps {
  payments: Payment[];
}

function formatCurrency(amount: number): string {
  return '£' + amount.toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

const PaymentsTable: React.FC<PaymentsTableProps> = ({ payments }) => {
  return (
    <div className="table-section">
      <h2 className="govuk-heading-m">Last 5 payments</h2>
      <table className="govuk-table">
        <thead className="govuk-table__head">
          <tr className="govuk-table__row">
            <th className="govuk-table__header">Date</th>
            <th className="govuk-table__header">Tax type</th>
            <th className="govuk-table__header govuk-table__header--numeric">Amount</th>
            <th className="govuk-table__header">Reference</th>
          </tr>
        </thead>
        <tbody className="govuk-table__body">
          {payments.map((item, index) => (
            <tr className="govuk-table__row" key={index}>
              <td className="govuk-table__cell">{item.date}</td>
              <td className="govuk-table__cell">{item.taxType}</td>
              <td className="govuk-table__cell govuk-table__cell--numeric">{formatCurrency(item.amount)}</td>
              <td className="govuk-table__cell">{item.reference}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentsTable;
